import React, { Component } from 'react';
import PropTypes from 'prop-types';
import marked from 'marked';
import { withRouter } from 'react-router-dom';
import './Markdown.css';

class Markdown extends Component {

    static propTypes = {
        text: PropTypes.string.isRequired
    };

    static defaultProps = {
        text: ''
    };

    constructor() {
        super();

        marked.setOptions({
            gfm: true,
            tables: true,
            breaks: false,
            pedantic: false,
            sanitize: true,
            smartLists: true,
            smartypants: false
        });
    }

    render() {
        const { text } = this.props;  
        const html = marked(text || '');

        return (<div>
            <div dangerouslySetInnerHTML={{__html: html}} />
        </div>);
    }
};

export default withRouter(Markdown);


// WEBPACK FOOTER //
// ./src/Markdown.js